var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentDiv',[_c('PageTitle',[_vm._v("Support")]),_c('p',[_vm._v("To increase situational awareness, we have developed a streaming solution, ESP (extra sensory perception), to consume, analyse and distribute payload data in real-time.")]),_c('PageTitleDivider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }